<div class="contador" [ngClass]="{ disabled: disabled }">
  <div
    class="contador__subtrair"
    (click)="subtrair()"
    [ngClass]="{ 'lovers--disabled': valorMinimoBlock >= valorAtual }"
  >
    <img class="subtrair__icone" src="assets/images/icons/menos_circulo.png" />
  </div>
  <div class="contador__valor">
    <p class="valor__atual">{{ valorAtual }}</p>
  </div>
  <div
    class="contador__adicionar"
    (click)="adicionar()"
    [ngClass]="{ 'lovers--disabled': valorMaximoBlock <= valorAtual }"
  >
    <img class="adicionar__icone" src="assets/images/icons/mais_circulo.png" />
  </div>
</div>
